export const theme = {
  fonts: {
    body: 'Montserrat, sans-serif',
    second: 'Jost,sans-serif',
    button: 'Roboto,sans-serif',
    signature: 'Mrs Saint Delafield, cursive',
  },

  fontSize: [16, 24, 34, 50, 75],

  fontWeights: {
    regular: 400,
    medium: 500,
    bold: 600,
  },

  colors: {
    bodyBg: '#fbf9f6',
    red: '#ff0044',
    black: '#232425',
    white: '#fff',
    grey: '#ccc',
    darkGrey: '#575150',
  },

  borderRadius: {
    small: '3px',
    round: '50px',
  },

  device: {
    mobile: `(min-width:320px)`,
    tablet: `(min-width:768px)`,
    desktop: `(min-width:1280px)`,
  },

  // device: {
  //   mobile: '320px',
  //   tablet: '768px',
  //   desktop: '1280px',
  // },

  // transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0s;

  //  @media ${p => p.theme.device.mobile} {
  // }

  // @media ${p => p.theme.device.tablet} {
  // }

  //  @media ${p => p.theme.device.desktop} {
  // }
};
